import React, { useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCalendar,
    faCloudDownloadAlt,
    faEdit,
    faEnvelope,
    faEye,
    faTrash,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { saveAs } from "file-saver";

import moment from "moment";
import "moment/locale/pt-br";

import { OverlayTrigger, Tooltip } from "react-bootstrap";

import "../styles.css";
import {
    DeletarDocumentoController,
    GetDocumentoUAUController,
} from "../../../../Controllers/Geral/CasoDocumentos/CasoDocumentosController";
import { IDocumento } from "../../../../Interfaces/Geral/CasoDocumentos/CasoDocumentosInterface";
import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Table";
import AnexarDocumento from "../AnexarDocumento";

import {
    DocumentoCasoContaController,
    InserirListaDocumentosCasoController,
} from "../../../../Controllers/Geral/Documentos/DocumentosController";
import ModalComponent from "../../../Modais";
import { IComponentModal } from "../../../Modais/IModalComponent";
import { EnviarEmail } from "../../../../Pages/Cobranca/Atendimento/ModalEnviarEmail";
import { groupBy } from "../../../../Tools/ProcessingTools";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import SpinnerComponent from "../../../Loding/Spinner";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import Swal from "sweetalert2";
import AtualizarDocumento from "../AtualizarDocumento";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { useHistoricoContext } from "../../../../Context/Historico";

interface IDocumentosProps {
    IDCaso?: number;
    IdConta?: number;

    lstDocs: Array<IDocumento> | undefined;
    updateDocumentos: () => void;

    loading?: boolean;

    tipoExibicao?: "CASO" | "CLIENTE" | "UAU";
}
interface IDocumentoComIcone extends IDocumento {
    icon_url?: string;
}

export default function ComponenteDocumentos(props: IDocumentosProps) {
    const { lstDocs, updateDocumentos, loading } = props;
    const [lstDocsFiltered, setLstDocsFiltered] =
        useState<Array<IDocumentoComIcone>>();

    const [MapTiposDocumentos, setMapTiposDocumentos] = useState(
        new Map() as Map<string, Array<IDocumento>>
    );

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { bloquearInteracoes } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    useEffect(() => {
        if (lstDocs) {
            setMapTiposDocumentos(
                groupBy(lstDocs, (doc) =>
                    doc.DocUAU ? "Documento UAU" : doc.DS_TIPO_DOCUMENTO
                )
            );
            setLstDocsFiltered(lstDocs);
        }
    }, [lstDocs]);

    //Tabela
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_DOCUMENTO",
            text: "Documentos",
            formatter: (cell, row) => <DocsRow {...row} />,
        },
    ];
    function DocsRow(row: IDocumentoComIcone) {
        const { execute: getDocumentoCaso, loading: getDocumentoCasoLoading } =
            useAsyncCallback(DocumentoCasoContaController);

        const [docUAU, setDocUau] = useState<Blob>();
        const [loading, setLoading] = useState(false);
        const [loadingEnviarEmail, setLoadingEnviarEmail] = useState(false);
        const [download, setDownload] = useState<string>();

        const hideName = row.DS_DOCUMENTO && row.DS_DOCUMENTO.length > 40;
        const fileName =
            row.DS_DOCUMENTO && hideName
                ? row.DS_DOCUMENTO.substring(0, 39) + "..."
                : row.DS_DOCUMENTO ?? "";

        const DocNameNode = !hideName ? (
            <span>{fileName}</span>
        ) : (
            <OverlayTrigger
                overlay={
                    <Tooltip className="text" id="tooltip-disabled">
                        {row.DS_DOCUMENTO}
                    </Tooltip>
                }
            >
                <span>{fileName}</span>
            </OverlayTrigger>
        );

        async function getDocUAU() {
            const doc =
                docUAU ??
                (await GetDocumentoUAUController({ ...row }).then((res) => {
                    setDocUau(res.response);
                    return new Blob([res.response], {
                        type: res.contentType,
                    });
                }));
            return doc as Blob;
        }

        function enviarDocPorEmail() {
            let promise: Promise<Blob>;
            if (row.DocUAU) promise = getDocUAU();
            else promise = handleGetDocumento();

            setLoadingEnviarEmail(true);
            promise
                .then((blob) => {
                    if (blob) {
                        const file = new File(
                            [blob],
                            row.DS_DOCUMENTO ?? "arquivo",
                            {
                                type: row.DS_TIPO,
                            }
                        );
                        setModal({
                            Component: () => (
                                <EnviarEmail
                                    ID_CASO={props.IDCaso ?? 0}
                                    ID_CONTA={props.IdConta ?? 0}
                                    ID_CONTATO={0}
                                    setShow={setShow}
                                    anexosDefault={[file]}
                                    assuntoDefault="Envio de Anexos"
                                />
                            ),
                            scrollable: true,
                            size: "xl",
                            headerComponent: "Enviar Email",
                        });
                        setShow(true);
                    }
                })
                .finally(() => {
                    setLoadingEnviarEmail(false);
                });
        }

        async function handleDocUrl() {
            const res = await getDocumentoCaso(row.ID_CASO_DOCUMENTO);
            const splitedLink = res.DS_LINK_DRIVE?.split("/");
            const driveFileId = splitedLink
                ? splitedLink[splitedLink.length - 2]
                : "00";
            const driveDownloadLink = `https://drive.google.com/uc?id=${driveFileId}&export=download`;
            const docDownloadURL = res.DS_LINK_DRIVE
                ? driveDownloadLink
                : `data:${row.DS_TIPO};base64,${res.IM_DOCUMENTO}`;
            return docDownloadURL;
        }

        async function handleDownloadDocumentoCaso() {
            setDownload(await handleDocUrl());
        }

        async function handleGetDocumento() {
            return fetch(await handleDocUrl(), {
                headers: {
                    "Content-Type": "application/octet-stream",
                },
                credentials: "include",
                mode: "no-cors",
            }).then((res) => res.blob());
        }

        useEffect(() => {
            if (download) {
                let aElement = document.createElement("a");
                aElement.href = download;
                aElement.download = row.DS_DOCUMENTO ?? "";

                aElement.click();
            }
        }, [download, row.DS_DOCUMENTO]);

        return (
            <div className="card card-custom gutter-b card-stretch documento ribbon ribbon-clip ribbon-right my-1 mx-5">
                {
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="tooltip-disabled">
                                Tipo de Documento
                            </Tooltip>
                        }
                    >
                        <div className="ribbon-target" style={{ top: "5px" }}>
                            <span className="ribbon-inner bg-info"></span>
                            {row.DocUAU
                                ? "Documento UAU"
                                : row.DS_TIPO_DOCUMENTO}
                        </div>
                    </OverlayTrigger>
                }
                <div className="card-body p-4 pt-6">
                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                        <div className="d-flex flex-wrap align-items-center mr-3">
                            <div className="d-flex flex-column">
                                <img
                                    alt="arquivo"
                                    className="file_icon"
                                    src={row.icon_url}
                                />
                                {loading ? (
                                    <button
                                        className="btn btn-success py-0"
                                        disabled
                                    >
                                        <div
                                            className="spinner-border spinner-border-sm text-light"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Carregando...
                                            </span>
                                        </div>
                                    </button>
                                ) : row.DocUAU ? (
                                    <button
                                        disabled={loading}
                                        onClick={async () => {
                                            setLoading(true);
                                            try {
                                                const doc = await getDocUAU();
                                                if (doc)
                                                    saveAs(
                                                        doc,
                                                        `${row.DS_DOCUMENTO?.replace(
                                                            " ",
                                                            ""
                                                        ).toLocaleLowerCase()}`
                                                    );
                                            } finally {
                                                setLoading(false);
                                            }
                                        }}
                                        className="btn btn-success py-0"
                                    >
                                        <FontAwesomeIcon
                                            icon={faCloudDownloadAlt}
                                        />
                                    </button>
                                ) : (
                                    <a
                                        href={download}
                                        download={row.DS_DOCUMENTO}
                                        className="btn btn-success py-0"
                                        onClick={() => {
                                            handleDownloadDocumentoCaso();
                                        }}
                                    >
                                        {getDocumentoCasoLoading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <FontAwesomeIcon
                                                icon={faCloudDownloadAlt}
                                            />
                                        )}
                                    </a>
                                )}

                                {props.IDCaso && !bloquearInteracoes && (
                                    <button
                                        className="btn btn-success py-0 mt-1"
                                        onClick={enviarDocPorEmail}
                                    >
                                        {loadingEnviarEmail ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <FontAwesomeIcon
                                                icon={faEnvelope}
                                            />
                                        )}
                                    </button>
                                )}
                            </div>

                            {row.DocUAU ? (
                                DocNameNode
                            ) : row.DS_LINK_DRIVE ? (
                                <a
                                    href={row.DS_LINK_DRIVE}
                                    className="text-dark-75 font-weight-bold m-2 font-size-lg text-break"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {DocNameNode}
                                    <FontAwesomeIcon
                                        icon={faEye}
                                        className="ml-2"
                                    />
                                </a>
                            ) : (
                                <span
                                    className="text-dark-75 font-weight-bold m-2 font-size-lg text-break"
                                    role="button"
                                    onClick={async () => {
                                        const blob = await handleGetDocumento();
                                        const url =
                                            window.URL.createObjectURL(blob);

                                        setModal({
                                            Children: (
                                                <object
                                                    data={url}
                                                    type={row.DS_TIPO}
                                                    style={{ minHeight: 500 }}
                                                    className="w-100"
                                                >
                                                    {row.DS_DOCUMENTO}
                                                </object>
                                            ),
                                            noHeader: true,
                                            noFooter: true,
                                            size: "lg",
                                        });
                                        setShow(true);
                                    }}
                                >
                                    {DocNameNode}
                                    <FontAwesomeIcon
                                        icon={faEye}
                                        className="ml-2"
                                    />
                                </span>
                            )}
                        </div>
                        <div className="d-flex flex-wrap flex-grow-1 justify-content-end">
                            <span className="label label-lg label-light-success label-inline text-uppercase font-weight-bold m-2">
                                <FontAwesomeIcon
                                    icon={faCalendar}
                                    className="mr-2"
                                />{" "}
                                {moment(row.DT_CADASTRO).format("lll")}
                            </span>
                            {row.DS_NOME && (
                                <span className="label label-lg label-light-primary label-inline text-uppercase font-weight-bold m-2">
                                    <FontAwesomeIcon
                                        icon={faUser}
                                        className="mr-2"
                                    />{" "}
                                    {row.DS_NOME}
                                </span>
                            )}
                            <div>
                                {
                                    <button
                                        className="btn text-primary btn-xl d-flex align-items-center flex-nowrap w-100"
                                        type="button"
                                        onClick={() => {
                                            if (row.ID_CASO_DOCUMENTO) {
                                                setShow(true);
                                                setModal({
                                                    Children: (
                                                        <AtualizarDocumento
                                                            setShow={setShow}
                                                            updateList={
                                                                updateDocumentos
                                                            }
                                                            documentos={
                                                                row as IDocumento
                                                            }
                                                        />
                                                    ),
                                                    noHeader: true,
                                                    noFooter: true,
                                                });
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faEdit}
                                            size="lg"
                                            className="mr-0"
                                        />
                                    </button>
                                }
                            </div>
                            <div>
                                {(row.DocUAU
                                    ? "Documento UAU"
                                    : row.ID_CASO_DOCUMENTO) && (
                                    <button
                                        className="btn text-danger btn-xl d-flex align-items-center justify-content-center flex-nowrap w-100"
                                        type="button"
                                        onClick={() => {
                                            Swal.fire({
                                                title: "Deseja apagar este Documento?",
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Sim!",
                                                showCancelButton: true,
                                                cancelButtonText:
                                                    "<i class='la la-thumbs-down'></i> Não",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                    cancelButton:
                                                        "btn btn-default",
                                                },
                                            }).then((result) => {
                                                if (
                                                    result.isConfirmed &&
                                                    (row.DocUAU
                                                        ? "Documento UAU"
                                                        : row.ID_CASO_DOCUMENTO)
                                                ) {
                                                    DeletarDocumentoController(
                                                        row.ID_CASO_DOCUMENTO
                                                    ).then(updateDocumentos);
                                                }
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faTrash}
                                            size="lg"
                                            className="mr-0"
                                        />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="card card-custom card-stretch pt-5 px-2">
            {props.tipoExibicao === "CASO" && (
                <div className="w-100">
                    <AnexarDocumento
                        handleSubmit={async (files) => {
                            if (props.IDCaso) {
                                await InserirListaDocumentosCasoController(
                                    files,
                                    props.IDCaso
                                ).then(() => {
                                    updateDocumentos();
                                    ReloadHistorico();
                                });
                            }
                        }}
                    />
                </div>
            )}
            {MapTiposDocumentos.size > 0 && (
                <div className="d-flex justify-content-end">
                    <select
                        className="form-control mb-2 w-25"
                        placeholder="Filtrar tipo documento"
                        onChange={(e) => {
                            const tipo = e.target.value;
                            if (tipo && MapTiposDocumentos.has(tipo))
                                setLstDocsFiltered(
                                    MapTiposDocumentos.get(tipo)
                                );
                            else setLstDocsFiltered(lstDocs);
                        }}
                    >
                        <option></option>
                        {Array.from(MapTiposDocumentos.keys()).map((tipo) => (
                            <option key={tipo}>{tipo}</option>
                        ))}
                    </select>
                </div>
            )}
            {loading ? (
                <SpinnerComponent />
            ) : (
                lstDocsFiltered && (
                    <Table
                        columns={columns}
                        data={lstDocsFiltered}
                        keyField="ID_CASO_DOCUMENTO"
                        noHover
                        bordered={false}
                        noDataIndication={() => (
                            <div className="text-black-50 text-center">
                                Nenhum documento vinculado
                            </div>
                        )}
                        loading={loading}
                        sizePerPage={2}
                    />
                )
            )}

            <ModalComponent
                ModalComponent={modal}
                setShow={setShow}
                show={show}
            />
        </div>
    );
}
